// Generated by scripts/build-ui-icons.mjs.
export { CurrencyCircleDollar as default } from "../ui/glyphs-3";
